import image1 from '@/assets/images/news/detail/20210226/1.webp';
import image2 from '@/assets/images/news/detail/20210226/2.webp';
import image3 from '@/assets/images/news/detail/20210226/3.webp';
import image4 from '@/assets/images/news/detail/20210226/4.webp';
import image5 from '@/assets/images/news/detail/20210226/5.webp';
import image6 from '@/assets/images/news/detail/20210226/6.webp';
import image7 from '@/assets/images/news/detail/20210226/7.webp';
import image8 from '@/assets/images/news/detail/20210226/8.webp';
import image9 from '@/assets/images/news/detail/20210226/9.webp';
import image10 from '@/assets/images/news/detail/20210226/10.webp';

export default {
  id: '20210226', //  模块 id
  title: '叮咚买菜首个自营基地落户金山！最快29分钟送到家', // 标题
  origin: '2021-02-26 来源：i金山', // 新闻来源
  editor: '编辑：陈薇婷', // 编辑者
  content: [
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: '你在叮咚买菜APP上买过菜吗？',
      isIndent: false,
    },
    {
      type: 0,
      text: '未来，',
      isIndent: false,
    },
    {
      type: 0,
      text: '你在这里买到的新鲜蔬菜',
      isIndent: false,
    },
    {
      type: 0,
      text: '可能就是产自咱大金山！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text:
        '日前，壹佰米网络科技有限公司（叮咚买菜）与金山区廊下镇政府签署了设置“叮咚买菜智慧农业示范园区"的战略合作协议，在金山区廊下镇万春村建设”叮咚买菜智慧农业示范园“。2月26日，基地里叮咚买菜种植的第一波蔬菜收割了，即将在叮咚买菜APP上架，供应上海全市。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '“收菜咯！”在上海金山区廊下镇叮咚买菜试验基地内，放眼望去全是一排排碧绿的菜畦和现代种植设施，第一批成熟的菠菜即将迎来收货，工人正忙着将收割的菠菜进行称重、装车。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text:
        '它们即将被运往叮咚买菜位于金山的分拣中心，进行分拣、包装。此后将通过全程冷链送往位于全市的200多个前置仓。市民在家拿起手机下个单，鲜灵灵的菠菜29分钟内就能送到家门口。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text:
        '“金山菜”从田间到市民餐桌的旅程不超过24小时，吃的就是本土的一个“鲜”字。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text:
        '2月26日，“叮咚农场上海廊下试验基地采收仪式”在上海市金山区廊下镇举行。据悉，通过与生鲜电商平台叮咚买菜进行合作，金山将进一步提高农业产业的生产、经营销售体系，促进廊下镇蔬菜保护镇建设，发展壮大集体经济，增加农民收入；将“农业+电商”、“农业+体验”、“农业+教育”等涵盖“吃、学、游”为一体的“农文旅”融合发展成为金山农业的一大特色。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
    {
      type: 0,
      text:
        '记者看到，叮咚买菜试验蔬菜基地占地面积200亩，基地已实现温室内自动灌溉设施、环控设施、空气土壤的温湿度监控设施，接通互联网后，可实现手机远程控制，农作物的生长全流程都可追溯可监测。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image8],
    },
    {
      type: 0,
      text:
        '“上海市民对绿叶菜的需求较大，第一批蔬菜种植了30亩菠菜、30亩芹菜，大概每天能够供应上海3000斤绿叶菜。接下来还将根据叮咚买菜的大数据预测系统，继续播种需求量高的莴笋、空心菜、西兰花、米苋菜等时令蔬菜，为春季蔬菜市场提供保障。”叮咚买菜智慧园总监孙国强介绍。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image9],
    },
    {
      type: 0,
      text:
        '这片试验蔬菜基地，是叮咚买菜建立的集标准生产、农产品加工、冷链配送、线上售卖为一体的智慧农业全产业链体系的一环。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '据了解，叮咚买菜正在逐渐深入地走向生产端，从源头加强农产品质量和食品安全保障。据介绍，这片试验基地从育种、培土、播种、培育、收割等全流程都由叮咚买菜进行，按照叮咚买菜的品质标准，采用绿色种植方式，持续减少化肥农药使用量，改善农村生态环境。未来这片基地还将打造成“绿色蔬菜”等GAP认证合作基地，发展绿色农产品、有机农产品和地理标志农产品。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image10],
    },
    {
      type: 0,
      text:
        '孙国强介绍，叮咚买菜试验基地还将形成自有示范基地运营体系、中外农业科技成果转化体系。以及建设生鲜分选加工区，形成进取型农业人才培育体系；还将落成科教培训中心，为当地农户提供种苗、培训和技术，形成叮咚买菜农业生态圈和全产业链布局，推动农村农业现代化发展，帮助农民打造一根“金扁担”。',
      isIndent: false,
    },
  ],
};
